/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class ListActionButton extends React.Component {
    render() {
        let className = 'list-action-button ' + this.props.buttonClass;

        return (
            <div className="list-action-wrapper">
                <div className={className} onClick={this.props.action} role="button" aria-label={this.props.buttonLabel}>
                    {this.props.buttonLabel}
                </div>
            </div>
        );
    }

};

ListActionButton.propTypes = {
    buttonClass: PropTypes.string,
    buttonLabel: PropTypes.string,
    action: PropTypes.func
};

ListActionButton.defaultProps = {
    buttonClass: '',
    buttonLabel: '',
    action: null
};

export default ListActionButton;
